/**
 * Formats a date for chat history display with relative time references
 *
 * Converts dates to user-friendly strings:
 * - Today: "Today HH:MM" (24-hour format)
 * - Yesterday: "Yesterday HH:MM" (24-hour format)
 * - Older: "Month Day, Year" format
 *
 * @param dateInput - The date to format (ISO string or Date object)
 * @returns Formatted date string for display in chat history
 *
 * @example
 * // Today's date
 * formatChatHistoryDate(new Date()) // "Today 14:30"
 *
 * @example
 * // Yesterday's date
 * formatChatHistoryDate(yesterday) // "Yesterday 09:15"
 *
 * @example
 * // Older date
 * formatChatHistoryDate("2024-01-15T10:30:00Z") // "January 15, 2024"
 */
export var formatChatHistoryDate = function (dateInput) {
    var inputDate = new Date(dateInput);
    var today = new Date();
    var yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    var inputDateOnly = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    var todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
    if (inputDateOnly.getTime() === todayOnly.getTime()) {
        var timeString = inputDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: false,
        });
        return "Today ".concat(timeString);
    }
    if (inputDateOnly.getTime() === yesterdayOnly.getTime()) {
        var timeString = inputDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: false,
        });
        return "Yesterday ".concat(timeString);
    }
    return inputDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};
